module.exports = __webpack_public_path__ + "twitter.svg?988f65e3a2a9b72ff5a1f541e10d1c54";


//////////////////
// WEBPACK FOOTER
// ./index_files/images/twitter.svg
// module id = 8
// module chunks = 0